import { jsxs as f, Fragment as h, jsx as t } from "react/jsx-runtime";
import { forwardRef as p, useRef as l, useImperativeHandle as b, useLayoutEffect as y } from "react";
import v from "classnames";
const g = p(
  ({
    showFullView: s = !1,
    dimmedStyle: i,
    onClickDimmed: a,
    children: m,
    className: c,
    ...d
  }, u) => {
    const e = l(null), r = l(null);
    return b(u, () => e.current), y(() => {
      if (!e.current)
        return;
      const o = () => {
        e.current && r.current && (r.current.style.bottom = `${e.current.clientHeight}px`);
      }, n = new ResizeObserver(o);
      return n.observe(e.current), o(), () => {
        n.disconnect();
      };
    }, []), /* @__PURE__ */ f(h, { children: [
      /* @__PURE__ */ t("div", { className: "dimmed_g", style: i, children: /* @__PURE__ */ t(
        "button",
        {
          type: "button",
          className: "screen_out",
          ref: r,
          onClick: a,
          children: "하프뷰 닫기"
        }
      ) }),
      /* @__PURE__ */ t(
        "div",
        {
          ref: e,
          className: v("modal_g modal_type2", c, {
            modal_full: s
          }),
          role: "dialog",
          "aria-labelledby": "modalTitle",
          ...d,
          children: /* @__PURE__ */ t("div", { className: "inner_modal", style: { height: "100%" }, children: m })
        }
      )
    ] });
  }
);
g.displayName = "BottomSheet";
export {
  g as default
};
